
import {Moment} from "moment";

export interface IMeteoCardData {
  month:number,
  decade: number,
  precipitation:number,
  precipitationChecksum:number,
  airTemp: number
}

export default class OperationalInputMeteoCardController {
  /**
   * Displayed water level data.
   */
  meteoData: IMeteoCardData;
}



/** WEBPACK FOOTER **
 ** ./app/operational/input/kn15-telegram/meteo-card.controller.ts
 **/